import type { Address } from "viem";

const TOKEN_ADDRESSES: Record<string, Address> = {
    AVAX: "0x0000000000000000000000000000000000000000",
    WAVAX: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    YAK: "0x59414b3089ce2AF0010e7523Dea7E2b35d776ec7",
    gmYAK: "0x3A30784c1af928CdFce678eE49370220aA716DC3",
    USDC: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
    JOE: "0x6e84a6216eA6dACC71eE8E6b0a5B7322EEbC0fDd",
    AUSD: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
    PRINCESS: "0xB310Ed3A7F4Ae79E59dCa99784b312c2D19fFC7C",
    KIMBO: "0x184ff13B3EBCB25Be44e860163A5D8391Dd568c1",
    COQ: "0x420FcA0121DC28039145009570975747295f2329",
};

const STRATEGY_ADDRESSES: Record<string, Address> = {
    YAK: "0x0C4684086914D5B1525bf16c62a0FF8010AB991A", // Yield Yak YAK
    USDC: "0xFB692D03BBEA21D8665035779dd3082c2B1622d0", // Benqi USDC
    gmYAK: "0x9db213cE52155A9462A869Af495234e4734DC08a", // Token Mill gmYAK
    PRINCESS: "0xA714d1f61D14F0beDecC0e0812A5641BD01424eD",
    JOE: "0x714e06410B4960D3C1FC033bCd53ad9EB2d1f874", // sJOE
};

const YAK_SWAP_CONFIG = {
    router: "0xC4729E56b831d74bBc18797e0e17A295fA77488c",
};

const TOKEN_MILL_CONFIG = {
    factory: "0x501ee2D4AA611C906F785e10cC868e145183FCE4",
};

export {
    TOKEN_ADDRESSES,
    STRATEGY_ADDRESSES,
    YAK_SWAP_CONFIG,
    TOKEN_MILL_CONFIG,
};
